import {Api} from "../api/api";
import {NotificationShowAll} from "./notification-show-all";
import NotificationsState from "./notifications-state/notifications-state";
import NotificationFullList from "./notification-full-list/notification-full-list";
import {NotificationRemoveButton} from "./notification-remove-button";
import {NotificationConfirm} from "./notification-confirm";
import {NotificationButton} from "./notification-button/notification-button";
import {NotificationModal} from "./notification-modal/notification-modal";
import {TaskType} from "./types";

const QueryType = {
  INITIAL: `INITIAL`,
  UPDATE: `UPDATE`,
  SHOW_ALL: `SHOW_ALL`,
};

const LIMIT = 100;

const backApi = new Api();

const notificationRequest = async (type: string) => {
  switch (type) {
    case QueryType.INITIAL:
      // return await backApi.customQuery(`/data/currentNotification2.json`, {method: `GET`});
      return await backApi.customQuery(`/notifications/list?limit=${LIMIT}`, {});
    case QueryType.SHOW_ALL:
      // return await backApi.customQuery(`/data/currentNotification3.json`, {method: `GET`});
      return await backApi.customQuery(`/notifications/list`, {});
    case QueryType.UPDATE:
      // return await backApi.customQuery(`/data/newNotification.json`, {method: `GET`});
      return await backApi.customQuery(`/notifications/list-new`, {});
  }
};

const collapsedLists = new Map();
const state = new NotificationsState();
let openNotificationsButton: NotificationButton;
let notificationsModal: NotificationModal;
let fullList: NotificationFullList;
let removeButton: NotificationRemoveButton;
let confirmModal: NotificationConfirm;
let showAll: NotificationShowAll;
let checkNotificationTimer: number;
let notificationsLoadingInitialized = false;

try {
  showAll = new NotificationShowAll(document.querySelector(`.js-notifications-show-all`)!);
} catch (error) {
  console.log(error);
}

try {
  openNotificationsButton = new NotificationButton(document.querySelector(`.js-notifications-btn`)!);
} catch (error) {
  console.log(error);
}

try {
  notificationsModal = new NotificationModal(document.querySelector(`.js-notifications-modal`)!);
} catch (error) {
  console.log(error);
}

try {
  removeButton = new NotificationRemoveButton(document.querySelector(`.js-notifications-remove`)!);
} catch (error) {
  console.log(error);
}

try {
  fullList = new NotificationFullList(document.querySelector(`.js-notification-list`)!);
} catch (error) {
  console.log(error);
}

try {
  confirmModal = new NotificationConfirm(document.querySelector(`.js-notification-confirm`));
} catch (error) {
  console.log(error);
}

const renderNotifications = (notifications, {taskName, parent, project, taskId, isSublist, isPrepend}) => {
  for (const notification of notifications) {
    if (notification.view.isNew) {

      const options = JSON.parse(JSON.stringify(notification));
      options.name = taskName;
      options.projectName = project.name;
      options.taskId = taskId;
      delete options.class;

      notification.view.renderElement(parent, options, isSublist, isPrepend);
      notification.view.isNew = false;
    }
  }
};

const checkNotifications = async (): Promise<void> => {
  type ResultType = {
    answer: {
      isNotifications: boolean
    },
    status: number
  };

  // const res: ResultType = await backApi.customQuery(`/data/check-notification.json`, {});
  const res: ResultType = await backApi.customQuery(`/notifications/is`, {});

  openNotificationsButton.setIsNewStatus(res.answer.isNotifications);
};

const addNewNotifications = (type: string) => {
  notificationRequest(type)
    .then((data) => {
      if (type === QueryType.INITIAL && data.length === LIMIT) {
        showAll.showButton();
      }

      if (type === QueryType.SHOW_ALL) {
        state.removeAllNotifications();
        fullList.removeAllElements();
        showAll.hideButton();
      }

      if (data.length > 0) {
        openNotificationsButton.setIsNewStatus(true);
      }

      // Создаем, рендерим и записываем в стейт списка, списки по датам
      data.forEach((task: TaskType) => {
        fullList.setNewDateList(task.date, type === QueryType.UPDATE);
      });


      // Инициализируем начальное состояние стейта уведомлений
      state.setInitialState(data);

      // Перебираем все таски в стейте для рендера уведомлений
      for (const [id, task] of state) {
        if (task) {
          const {view, notifications, date, name, project} = task;

          // Если добавление новых элементов к существующим, то обновляем счетчик во вью
          if (type === QueryType.UPDATE) {
            view.updateCount(state.getTaskNotificationCount(id));
          }

          // Если уведомлений нет, то переходим к следующей таске
          if (view.getCount() === 0) {
            continue;
          }

          // Ищем родителя по дате
          const parent = fullList.getSubListElement(date);

          // Рендерим уведомление если оно только одно
          if (view.getCount() === 1) {
            renderNotifications(notifications.values(), {
              taskName: name,
              parent,
              project,
              taskId: id,
              isSublist: false,
              isPrepend: false,
            });
            view.isOneNotification = true;
            continue;
          }

          // Рендер нескольких уведомлений в одной задаче

          if (type === QueryType.UPDATE) {
            // Если ранее был рендер только одного уведомления, то удаляем его, и переключаем статус в новый
            if (view.isOneNotification) {
              for (const notification of notifications.values()) {
                if (!notification.view.isNew) {
                  notification.view.removeElement();
                  notification.view.isNew = true;
                  break;
                }
              }
              view.isOneNotification = false;
            }

            // Проверяем, что если есть дата и она не равняется новой дате, то переносим коллапс блок в новую дату
            if (view.getHtmlElementDate() !== undefined && view.getHtmlElementDate() !== date) {
              const oldDate = view.getHtmlElementDate();
              view.moveElementToNewDate();

              // Если по итогу родитель остался пустой, то удаляем
              if (fullList.getItemElementChildrenLength(oldDate) < 1) {
                fullList.removeItemElement(oldDate);
              }
            }
          }

          view.renderElement();
          renderNotifications(notifications.values(), {
            taskName: name,
            parent: view.getListElement(),
            project,
            taskId: id,
            isSublist: true,
            isPrepend: type === QueryType.UPDATE,
          });

          // Если добавление новых элементов к существующим, то обновляем счетчик на элементах
          if (type === QueryType.UPDATE) {
            view.updateCountElement();
          }

          view.initCollapseScript();
        }
      }

      if (state.getLength() > 0 && removeButton) {
        // removeButton.setCount(state.getLength());
        removeButton.showButton();
      }
    });
};

const notifications = async () => {
  if (document.querySelector(`.js-notification-list`)) {
    window.addEventListener(`load`, async () => {

      await checkNotifications();

      checkNotificationTimer = window.setInterval(async () => {
        await checkNotifications();
      }, 120000);

      showAll.setClickHandler(() => {
        addNewNotifications(QueryType.SHOW_ALL);
      });

      openNotificationsButton.setClickHandler(() => {
        clearInterval(checkNotificationTimer);

        if (!notificationsModal.getModalActivityStatus()) {
          notificationsModal.showModal();

          if (!notificationsLoadingInitialized) {
            notificationsLoadingInitialized = true;

            addNewNotifications(QueryType.INITIAL);

            // setTimeout(() => {
            //   addNewNotifications(QueryType.UPDATE);
            // }, 10000);

            setInterval(() => {
              addNewNotifications(QueryType.UPDATE);
            }, 120000);
          }
        } else {
          notificationsModal.hideModal();
        }
      });
    });
  }
};

export {state, fullList, collapsedLists, confirmModal, removeButton, openNotificationsButton};
export default notifications;
